import { LoginService } from './../auth/login.service';
import { NotificationConst } from './../../const/shared/notification-const';
import { ResponseAmf } from './../../model/shared/response-amf';
import { Injectable } from '@angular/core';
import { AlertService } from '../shared/alert.service';
import { NotificationService } from '../shared/notification.service';
import {MensagemConst} from "../../const/shared/mensagem-const";

@Injectable({
  providedIn: 'root'
})

export class InterceptAmfService {

  constructor(
    private _alertService: AlertService,
    private _loginService: LoginService,
    private _notificationService: NotificationService
  ) { }

  async interceptAmf(clientAmf, model, method, param, sessionId): Promise<ResponseAmf>{
    try {
      return await clientAmf.invoke( model, method, param, sessionId);
    } catch (e) {
      console.error('error amf', e);
      this.verificaErroSessaoAmf(e);
      this._notificationService.error(NotificationConst.TITLE_DEFAULT, this.getMensagemErro(e.message));
    }
    return null;
  }

  private getMensagemErro(mensagem) {
    let mensagemArray: string [] = mensagem.split(':');
    if(mensagemArray.length > 0){
      if(mensagemArray.length >= 2){
        let mensagem = "";
        mensagemArray.forEach((msg, i) => {
          if(i > 0){
            mensagem += ":" + msg;
          }
        })
        return mensagem;
      }
      return mensagemArray[0];
    }
    return "";
  }

  verificaErroSessaoAmf(res){
    if(res.data.rootCause.message == MensagemConst.MSGSESSAONAOOK){
      this._alertService.messageV2(NotificationConst.TITLE_WARNING, "Sua sessão não está ativa. Efetue o login novamente!", 'warning');
      setTimeout(async () => {
        await this._loginService.logOut();
        window.location.reload();
      }, 3000);
    }
  }
}